import WantToRegister from './WantToRegister';

export default WantToRegister;